// The page bar's own button look, as Edit view has on a record page.
export const PageBarButtonClass =
  "btn border rounded-2 bg-white text-dark fw-medium hover-bg-light d-inline-flex align-items-center";
